<template>
  <section v-if="tickets.length" class="c4-past" :aria-label="tx('past.title')">
    <div class="c4-past-h">
      <b>{{ tx("past.title") }}</b>
      <span>
        {{ tx("past.vanish") }} {{ clock }}
        <button type="button" data-fk="clearall" @click="$emit('clear')">{{ tx("past.clear") }}</button>
      </span>
    </div>
    <div class="c4-past-g">
      <button
        v-for="tk in shown"
        :key="tk.id"
        type="button"
        class="c4-pc"
        :data-tone="kinds[tk.kind].tone"
        :data-fk="'pc' + tk.id"
        :aria-label="label(tk)"
        @click="$emit('open', tk.id)"
      >
        <i class="mdi" :class="kinds[tk.kind].icon" aria-hidden="true"></i>
        <span class="c4-pc-n">{{ who(tk) }}</span>
        <i v-if="unconfirmed(tk)" class="mdi mdi-alert-circle-outline w" aria-hidden="true"></i>
        <span class="c4-pc-t">{{ tk.doneAt || tk.at }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";
import { KINDS } from "@/utils/canteenOutcome";

export default {
  name: "CanteenPast",
  mixins: [canteenV4Text],
  props: {
    tickets: { type: Array, default: () => [] },
    // koliko ih se prikazuje (četiri u redu, ili dvije kad je na ekranu četiri i više korisnika)
    limit: { type: Number, default: 4 },
    // sekundi do čišćenja ekrana
    left: { type: Number, default: 0 },
  },
  data() {
    return { kinds: KINDS };
  },
  computed: {
    shown() {
      return this.tickets.slice(0, this.limit);
    },
    clock() {
      const l = Math.max(0, this.left);
      return `${Math.floor(l / 60)}:${String(l % 60).padStart(2, "0")}`;
    },
  },
  methods: {
    who(tk) {
      const u = tk.outcome.user;
      if (!u) return tk.code ? `ID ${tk.code}` : this.tx("o." + tk.kind);
      const first = this.toLatin(u.name);
      const last = this.toLatin(u.lastname);
      return last ? `${first} ${last.charAt(0)}.` : first;
    },
    unconfirmed(tk) {
      return KINDS[tk.kind].can && tk.conf !== "done";
    },
    label(tk) {
      return `${this.who(tk)}, ${this.tx("o." + tk.kind)}${
        this.unconfirmed(tk) ? ", " + this.tx("past.unconf") : ""
      }`;
    },
  },
};
</script>
